import { trackGtag } from 'utils/analytics';
import { isPrerendering } from 'utils/prerender';

/**
 * GA4 events for the goodie campaign (QR code on the goodie card). They go
 * through the existing gtag setup in public/index.html, so consent mode and
 * GTM keep working exactly as for the rest of the site.
 *
 * Calendly clicks are additionally counted as `calendly_link_click` by the
 * global listener in app/App.jsx; the Google Ads conversion fires only once a
 * booking is completed in the Calendly overlay.
 */
export const GOODIE_EVENTS = {
  pageView: 'goodie_page_view',
  demoClick: 'goodie_demo_click',
  featureScroll: 'goodie_feature_scroll',
};

/**
 * @param {string} eventName One of GOODIE_EVENTS
 * @param {object} [params] Extra event parameters (e.g. placement)
 * @returns {boolean} Whether the event was handed to gtag
 */
export const trackGoodieEvent = (eventName, params = {}) => {
  if (isPrerendering()) return false;
  return trackGtag(eventName, {
    campaign: 'goodie',
    page_path: window.location.pathname,
    ...params,
  });
};
